export default {"src":"/_next/static/media/whtspp.7e629d75.svg","height":24,"width":25};